import { useQuery } from '@tanstack/react-query';
import { FeedsQueryKeys } from './feeds.keys';
import apiClient from '../ApiClient';

const savedPost = async (): Promise<any> => {
  const res = await apiClient.get('bookmarks');
  return res.data?.data;
};

export const useFetchSavedFeeds = () => {
  return useQuery({
    queryKey: FeedsQueryKeys.saved,
    queryFn: () => savedPost(),
  });
};
